import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { from, switchMap, catchError } from 'rxjs';
import { AUTH_SCOPES } from './auth.config';

const PROTECTED_URLS = [
  'http://localhost:3000/api',
  'https://ecs33budgets-api-hqabh0bef4bggugp.centralus-01.azurewebsites.net/api',
];

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const isProtected = PROTECTED_URLS.some((url) => req.url.startsWith(url));
  if (!isProtected) return next(req);

  const msal = inject(MsalService);
  const account = msal.instance.getActiveAccount()
    ?? msal.instance.getAllAccounts()[0];

  if (!account) return next(req);

  return from(
    msal.instance.acquireTokenSilent({
      scopes:  AUTH_SCOPES.api,
      account,
    })
  ).pipe(
    switchMap((result) => {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${result.accessToken}` },
      });
      return next(authReq);
    }),
    catchError(() => next(req))
  );
};
